<template>
<div>
    <v-navigation-drawer color="grey lighten-4" hide-overlay permanent v-if="mock" mini-variant app fixed disable-resize-watcher :clipped="true">
        <div class="py-2">
            <v-list class="dropdown-submenu pa-0 pl-2" nav dense v-for="(item, i) in catalogTree().menuItems" :key="i">
                <div class="v-list-group__header v-list-item v-list-item--link theme--light py-1 pb-2" @click="mock = false">
                    <v-list-item-icon>
                        <v-icon v-text="item.icon" :title="item.text"></v-icon>
                    </v-list-item-icon>
                </div>
            </v-list>
            <template v-if="!contactInfo.isSellToEmployee && !contactInfo.isGuest && contactInfo.realUserId > 0">
                <v-list class="dropdown-submenu pa-0 pl-2" nav dense>
                    <div class="v-list-group__header v-list-item v-list-item--link theme--light py-1 primary--text" @click="mock = false">
                        <v-list-item-icon>
                            <v-icon color="primary" title="ТОП пропозиції">mdi-basket-outline</v-icon>
                        </v-list-item-icon>
                    </div>
                </v-list>
            </template>

        </div>
    </v-navigation-drawer>
    <v-navigation-drawer v-show="!mock" hide-overlay id="navigation-drawer" :class="{hidden}" permanent width="340" v-model="$store.state.main.navigationDrawerOpened" app fixed :style="cssProps" :expand-on-hover="$route.name != 'home'" disable-resize-watcher :clipped="$vuetify.breakpoint.smAndUp">
        <div id="navbar" class="py-2 height_js" :style="cssProps">
            <v-list class="dropdown-submenu pa-0 pl-2" nav dense v-for="(item, i) in catalogTree().menuItems" :key="i">
                <div class="v-list-group__header v-list-item v-list-item--link theme--light py-1" @click="gotoLink(item.link)">
                    <v-list-item-icon>
                        <v-icon v-text="item.icon"></v-icon>
                    </v-list-item-icon>
                    <v-list-item-title>{{item.text}}</v-list-item-title>
                    <v-list-item-icon v-if="catalogTree().menuSubItems[item.link]">
                        <v-icon>mdi-chevron-right</v-icon>
                    </v-list-item-icon>
                </div>
                <div v-if="catalogTree().menuSubItems[item.link]" class="dropdown-menu height_js mod py-2">
                    <v-list nav dense v-for="(subItem, idx) in catalogTree().menuSubItems[item.link]" :key="idx" class="dropdown-submenu pa-0">
                        <div :class="`v-list-group__header v-list-item v-list-item--link theme--light py-1 ` + (catalogTree().menuSubItems[subItem.link] ? '': 'mb-1')" @click.stop="gotoLink(subItem.link)">
                            <v-list-item-title class="pl-4">{{subItem.text}}</v-list-item-title>
                            <v-list-item-icon v-if="catalogTree().menuSubItems[subItem.link]">
                                <v-icon>mdi-chevron-right</v-icon>
                            </v-list-item-icon>
                        </div>
                        <div v-if="catalogTree().menuSubItems[subItem.link]" class="dropdown-menu menu-categories px-2">
                            <div class="menu-categories-list height_js ">
                                <div v-for="(subItem1, idx1) in catalogTree().menuSubItems[subItem.link]" :key="idx1" @click.stop="gotoLink(subItem1.link)" class="menu-categories-list__item pa-2" :style="cssProps">
                                    <v-img v-if="subItem1.img" height="100" width="100" class="menu-categories-list__img" :src="'https://b2b.yugcontract.ua/fileslibrary/ws/images/catalog/'+subItem1.img" :lazy-src="nophoto"></v-img>
                                    <v-img v-else height="100" width="100" class="menu-categories-list__img" :src="nophoto" alt="Img"></v-img>
                                    <span>{{subItem1.text}}</span>
                                </div>
                            </div>
                        </div>
                    </v-list>
                </div>
            </v-list>
            <template v-if="!contactInfo.isSellToEmployee && !contactInfo.isGuest && contactInfo.realUserId > 0">
                <v-list class="dropdown-submenu pa-0 pl-2" nav dense>
                    <div class="v-list-group__header v-list-item v-list-item--link theme--light py-1 primary--text" @click="gotoLink('/shopping-guide')">
                        <v-list-item-icon>
                            <v-icon color="primary">mdi-basket-outline</v-icon>
                        </v-list-item-icon>
                        <v-list-item-title>ТОП пропозиції</v-list-item-title>
                    </div>
                </v-list>
            </template>
        </div>
    </v-navigation-drawer>
</div>
</template>

<script>
import {
    mapActions,
    mapGetters
} from 'vuex'

export default {
    props: {
        drawer: Boolean
    },
    data() {
        return {
            nophoto: 'data:image/png;base64,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',
            items: [],
            error: [],
            menuLoading: false,
            status: 0,
            hidden: false,
            height: 0,
            mock: true
        }
    },
    methods: {
        ...mapActions(['getCatalogTree', 'getBreadCrumbs', 'touch']),
        ...mapGetters(['catalogTree']),
        hide() {
            this.hidden = true
            setTimeout(() => {
                this.hidden = false
            }, 1000);
        },
        gotoLink: function (link) {
            this.hide()
            setTimeout(() => {
                if (typeof link === 'number') {
                    if (this.$route.path != `/list/${link}`) {
                        this.$router.push(`/list/${link}`)
                        this.hide()
                        const options = this.getLocalStorage('catalogListOptions')
                        options.page = 1
                        this.setLocalStorage('catalogListOptions', options)
                    }
                } else {
                    if (this.$route.path != link) {
                        this.$router.push(link)
                        this.hide()
                    }
                }
            }, 700);

        },
        getLocalStorage(f) {
            let value = ''
            try {
                value = localStorage[f] ? JSON.parse(localStorage[f]) : ''
            } catch (error) {
                console.error(error)
                return ''
            }
            return value
        },

        setLocalStorage(f, v) {
            localStorage[f] = JSON.stringify(v)
        },
        fixMenu() {
            this.mock = false
            let timerId = setInterval(() => {
                if (this.height < 30) {
                    let el = document.getElementsByClassName('height_js');
                    for (let element of el) {
                        let val = element.offsetHeight
                        if (val > this.height) {
                            this.height = val;
                        }
                    }
                    for (let element of el) {
                        element.style.height = this.height + 'px';
                    }
                    if (this.height > 30) {
                        clearInterval(timerId);
                    }
                    if (this.$route.name != 'home') {
                        this.mock = true
                    }
                }
            }, 1000);
        }
    },
    watch: {
        '$route.path'() {
            if (this.$route.name != 'home') {
                this.mock = true
            } else {
                this.mock = false
            }
        },
        mock(v) {
            if (!v) {
                this.fixMenu()
                setTimeout(() => {
                    if (this.$route.name != 'home') {
                        this.mock = true
                    }
                }, 15000);
            }
        }
    },
    created() {},
    mounted() {
        this.touch()
            .then(() => {
                this.getCatalogTree()
                    .then(() => {
                        this.fixMenu()
                        if (this.$route.name == 'home') {
                            this.mock = false
                        }
                    })
                this.getBreadCrumbs()
            })
    },
    computed: {
        cssProps() {
            return {
                '--primary-color': this.$vuetify.theme.themes.light.primary,
                '--menu-bg-color': '#ededed'
            }
        },
        contactInfo() {
            return this.$store.state.main.contactInfo
        },
    }
}
</script>

<style scoped>
.dropdown-submenu:hover>div {
    background-color: #f0f0f0;
}

#navbar {
    height: 100vh;
    max-height: 100%;
    width: 100%;
    z-index: 2;
    height: auto;
    background-color: var(--menu-bg-color);
}

#navigation-drawer {
    background-color: var(--menu-bg-color);
}

.v-navigation-drawer__border {
    background: #000 !important;
}

.v-navigation-drawer {
    overflow: visible !important;
}

#navbar:hover {
    box-shadow: 0 0 5px 0 rgba(50, 50, 50, .4);
    background-color: #ffffff;
}

#navigation-drawer .theme--light.v-list-item:hover::before {
    opacity: 0;
}

.dropdown-menu {
    position: absolute;
    top: 0;
    left: 100%;
    width: 340px;
    background-color: #fff;
    z-index: -1;
    visibility: hidden;
    transform: translateX(-100%);
    transition: transform .3s ease-in-out, visibility .3s ease-in-out, opacity .3s ease-in-out, box-shadow .5s;
    transition-delay: .12s;
}

.dropdown-menu.active {
    visibility: visible;
    transform: translateX(0);
}

.dropdown-submenu:hover>.dropdown-menu {
    opacity: 1;
    visibility: visible;
    transform: translateX(0);
    transition-delay: .12s;
}

.dropdown-submenu:hover>.mod.dropdown-menu:before {
    box-shadow: 0 0 5px 0 rgba(50, 50, 50, .4);
}

#navigation-drawer.hidden .dropdown-menu {
    visibility: hidden !important;
    transform: translateX(-100%) !important;
    transition-delay: .0s;
}

.mod.dropdown-menu:before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    z-index: 0;
    transition: box-shadow .5s;
    transition-delay: .5s;
}

.menu-categories {
    width: 693px;
    box-shadow: 0 0 5px 0 rgba(50, 50, 50, .4);
    background-color: #fff !important;
    transition-delay: .2s !important;
}

.menu-categories-list {
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-wrap: wrap;
    -ms-flex-wrap: wrap;
    flex-wrap: wrap;
    align-content: flex-start;
    -webkit-align-items: flex-start;
    -ms-flex-align: start;
    align-items: flex-start;
    padding-bottom: 10px;
}

.menu-categories-list__item {
    display: -ms-flexbox;
    display: -webkit-flex;
    display: flex;
    -webkit-flex-direction: column;
    -ms-flex-direction: column;
    flex-direction: column;
    text-align: center;
    width: 25%;
    font-size: 0.8125rem;
    font-weight: 500;
    line-height: 1rem;
    cursor: pointer;
    padding: 0 5px;
    margin-bottom: 10px;
    transition: color .3s;
}

.menu-categories-list__item:hover {
    color: var(--primary-color);
}

.menu-categories-list__img {
    display: block;
    margin: 10px auto;
    max-height: 100px;
    max-width: 100%;
}

#navbar .v-list-item {
    min-height: 40px;
}

@media screen and (max-width: 1400px) {
    .menu-categories {
        width: 600px;
    }
}

@media screen and (max-width: 1300px) {
    .menu-categories {
        width: 550px;
    }
}

/* #navbar .v-list-group__header .v-list-item__title::after {
    content: " ";
    background: grey;
    height: 1px;
    position: absolute;
    bottom: 0;
    display: block;
} */
</style>
